import _ from 'lodash';
import { preload, goto } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { fetchToSPage, acceptTermsAndConditions } from 'app/api/legal-api';
import TermsAndConditions from 'app/common/components/terms-and-conditions';
import features from 'app/common/containers/features';
import { getChromeVersion, isEdge } from '../../util';

const mapStateToProps = state => ({
  terms: _.get(state, 'legal.termsOfServicePage'),
  pageTitle: 'Terms of Service',
  downloadUrl: `${_.get(state.common, 'features').GFCORE_SITE_URL}/setup/download`,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  goToNext: (termsVersion, downloadUrl) => {
    dispatch(acceptTermsAndConditions(termsVersion)).then(() => {
      if (ownProps.location.query.entry === 'new_user') {
        dispatch(goto('/setup/finished'));
      } else if (window.sessionStorage.getItem('disallowedSetupChromeVersion')
        || getChromeVersion() >= 101 || isEdge()) {
        window.location.replace(downloadUrl);
      } else {
        dispatch(goto('/setup/select'));
      }
    });
  },
});

const TermsAndConditionsContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch }) => Promise.all([
    dispatch(fetchToSPage()),
  ]))(TermsAndConditions),
);

export default features(TermsAndConditionsContainer);



// WEBPACK FOOTER //
// ./app/containers/setup/terms-and-conditions.js